
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as AIzAcxrzraBvZtDazD_w1J4TrVB_45NfrpdsU9LDQu4YjTsMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/AI.vue?macro=true";
import { default as aboutjOJVMTMwY7dSr2_454zf4rTuHb1gQbVLgylMRr5w0vL6sMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/about.vue?macro=true";
import { default as index008mBNiuNebsl8a51gsL2BQZPaJxR4TRu8PCsAtJoD8Meta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/index.vue?macro=true";
import { default as indexR3lztN_45cMxiMq9gJzxe6H6L_ePZUs_vmwtw5TzPSvycMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/m/index.vue?macro=true";
import { default as login_zUSROV_d_453JjZRw0xcSMNhbNf_45QJ5kNyXveJTs7NigMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/m/login.vue?macro=true";
import { default as promotew9ij0YiHIZhSorRVdW6Bb_H_d5ofv9ajjXQA6i5qsbAMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/promote.vue?macro=true";
import { default as activityug2xtqGgNy5ZYN_JHF8e_45W_45l1fnUIIJWgzLMt6QOIk0Meta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/activity.vue?macro=true";
import { default as showcasevWDOCYfezNo718lt_eb3ctFbKrAJQ7VUiXHA2nbRwx4Meta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/showcase.vue?macro=true";
import { default as liveClassGswVRekIlxBaLjSFfTqkKxkGGOhtvplyi8_45vq_45l0g_45UMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/liveClass.vue?macro=true";
import { default as NewdmeXq3QSt7DqyUEDrGgoL3HDNtmdULmitNs0OHRhbEsMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/attend/New.vue?macro=true";
import { default as classDetail8KwdZyzjvwr7NenDdEFF0Yy32HJu_45sbcF6sYyqRlJqEMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/classDetail.vue?macro=true";
import { default as indexW0bI7qsUymzus9uWKJLmXxkGp9L1A8koe8X7_ORybWIMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/attend/index.vue?macro=true";
import { default as galleryDetailKgVpvGUrbi3yKjfcaHuxOmC2yet1cuYzZVdKv8a4rewMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/galleryDetail.vue?macro=true";
import { default as showcaseJudge9Urb1dcAiuBWEYz_45urFuWr4BdbDrepEmW2ys41CRYLEMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/showcaseJudge.vue?macro=true";
import { default as indexKK22Tllyv8uNQwGM5za_S3ZUNw4rthw5UD2D554tHk0Meta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/articles/index.vue?macro=true";
import { default as personalCenterRkw0SofH3suTrErUK6f2xdjg4dWsVpZsOPDyeyHoDrMMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/personalCenter.vue?macro=true";
import { default as projectGallery1rO4VUbUPgaIFqUZDmEATKPD75yqf6bnY75gT3lh0wAMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/projectGallery.vue?macro=true";
import { default as sourceDownloadjghGTjJp3qUQRUXXzs7NPnFmfCowPWyRkVRgSbwJxa0Meta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/sourceDownload.vue?macro=true";
import { default as showcaseRegistermypqbwUnSfapn3OCDkBed1BPhW9bdtPI6s19GO_45d2fYMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/showcaseRegister.vue?macro=true";
import { default as learningResourcesyM3r6IXAdfx55fkBEt4tahb1CjlxCpWjUS8xD_9hsAoMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/learningResources.vue?macro=true";
import { default as _91id_93NlwKxOTO5qbnLExnR4rNUeiQ7nkS6lXYN9Y1Q1_45GMCEMeta } from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/articles/detail-[time]/[id].vue?macro=true";
export default [
  {
    name: "AI",
    path: "/AI",
    meta: {"middleware":["auth"]},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/AI.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/index.vue")
  },
  {
    name: "m",
    path: "/m",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/m/index.vue")
  },
  {
    name: "m-login",
    path: "/m/login",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/m/login.vue")
  },
  {
    name: "promote",
    path: "/promote",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/promote.vue")
  },
  {
    name: "activity",
    path: "/activity",
    meta: {"middleware":["auth"]},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/activity.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/showcase.vue")
  },
  {
    name: "liveClass",
    path: "/liveClass",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/liveClass.vue")
  },
  {
    name: "attend-New",
    path: "/attend/New",
    meta: NewdmeXq3QSt7DqyUEDrGgoL3HDNtmdULmitNs0OHRhbEsMeta || {},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/attend/New.vue")
  },
  {
    name: "classDetail",
    path: "/classDetail",
    meta: classDetail8KwdZyzjvwr7NenDdEFF0Yy32HJu_45sbcF6sYyqRlJqEMeta || {},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/classDetail.vue")
  },
  {
    name: "attend",
    path: "/attend",
    meta: indexW0bI7qsUymzus9uWKJLmXxkGp9L1A8koe8X7_ORybWIMeta || {},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/attend/index.vue")
  },
  {
    name: "galleryDetail",
    path: "/galleryDetail",
    meta: galleryDetailKgVpvGUrbi3yKjfcaHuxOmC2yet1cuYzZVdKv8a4rewMeta || {},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/galleryDetail.vue")
  },
  {
    name: "showcaseJudge",
    path: "/showcaseJudge",
    meta: {"middleware":["auth"]},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/showcaseJudge.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: {"middleware":["auth"]},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/articles/index.vue")
  },
  {
    name: "personalCenter",
    path: "/personalCenter",
    meta: { ...(personalCenterRkw0SofH3suTrErUK6f2xdjg4dWsVpZsOPDyeyHoDrMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/personalCenter.vue")
  },
  {
    name: "projectGallery",
    path: "/projectGallery",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/projectGallery.vue")
  },
  {
    name: "sourceDownload",
    path: "/sourceDownload",
    meta: {"middleware":["auth"]},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/sourceDownload.vue")
  },
  {
    name: "showcaseRegister",
    path: "/showcaseRegister",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/showcaseRegister.vue")
  },
  {
    name: "learningResources",
    path: "/learningResources",
    meta: {"middleware":["auth"]},
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/learningResources.vue")
  },
  {
    name: "articles-detail-time-id",
    path: "/articles/detail-:time()/:id()",
    component: () => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/pages/articles/detail-[time]/[id].vue")
  }
]